import React, { useEffect, useState, useMemo } from "react";
import styles from "@/components/CustomComponents/ProToolBox/index.module.scss";
import ToolCard from "@/components/CustomComponents/ProToolBox/Card";

const toolBoxData = {
  heading: "Pro Toolbox",
  images: [
    {
      src: "https://kohler.scene7.com/is/image/PAWEB/zab90557_rgb?crop=(7,0,2962,2291)",
      alt: "Stewardship",
      description:
        "This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown.",
      name: "Stewardship",
      showReverse: false,
      buttonLink: "https://kohler.com",
      buttonLabel: "Learn More",
    },
    {
      src: "https://kohler.scene7.com/is/image/PAWEB/zab90557_rgb?crop=(7,0,2962,2291)",
      alt: "Stewardship",
      description:
        "This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown.",
      name: "Stewardship",
      showReverse: true,
      buttonLink: "https://kohler.com",
      buttonLabel: "Learn More",
    },
    {
      src: "https://kohler.scene7.com/is/image/PAWEB/zab90557_rgb?crop=(7,0,2962,2291)",
      alt: "Stewardship",
      description:
        "This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown. This article is light grey and the text is brown.",
      name: "Stewardship",
      showReverse: false,
      buttonLink: "https://kohler.com",
      buttonLabel: "Learn More",
    },
  ],
};
const ProToolBox = () => {
  if (!toolBoxData) return null;
  const { heading = "", images = [] } = toolBoxData;
  return (
    <div className={styles.wrapper}>
      <div className="px-3">
        <div className="articleContent">
          {heading ? (
            <p className="koh-pro-toolbox-title text-xl md:text-3xl text-[#000]">
              {heading}
            </p>
          ) : null}
        </div>
        {images.map((imageData, index) => (
          <ToolCard key={index} {...imageData} />
        ))}
        <hr className=" flex-grow line" />
      </div>
    </div>
  );
};

export default ProToolBox;
